import React from "react";

export const colors = {
  white: "#FFFFFF",
  primary: "#584690",
  primaryDark: "#4B367C",
  primarySoft: "#E9DDFE",
  primarySofter: "#F2EBFF",
  text: "#2F2840",
  textDark: "#6A6469",
  textBody: "#6D6675",
  border: "#E7E0F2",
  borderSoft: "#E2DDEE",
  inputBg: "#FFFFFF",
  inputText: "#534D58",
  successBg: "#ECFDF3",
  successText: "#166534",
  successBorder: "#BBF7D0",
  errorBg: "rgba(239,68,68,0.10)",
  errorBorder: "rgba(239,68,68,0.22)",
  errorText: "#991B1B",
};

export const shadowCard = "0 4px 14px rgba(40, 24, 82, 0.10)";
export const shadowSoft = "0 2px 10px rgba(40, 24, 82, 0.08)";

export const inputBaseStyle = {
  width: "100%",
  minHeight: 46,
  borderRadius: 12,
  border: `1.5px solid ${colors.border}`,
  background: colors.inputBg,
  padding: "0 14px",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  color: colors.inputText,
  outline: "none",
  boxSizing: "border-box",
};

export const selectStyle = {
  ...inputBaseStyle,
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  paddingRight: 42,
};

export const labelStyle = {
  display: "block",
  marginBottom: 6,
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  color: colors.textDark,
};

export const titleStyle = {
  fontFamily: "Montserrat, sans-serif",
  fontWeight: 700,
  color: colors.primary,
};

export const sectionCardStyle = {
  background: colors.white,
  borderRadius: 18,
  border: `1px solid ${colors.border}`,
  boxShadow: shadowCard,
  padding: 14,
};

export const readOnlyFieldStyle = {
  paddingBottom: 12,
  borderBottom: `1px solid ${colors.border}`,
};

export const readOnlyValueStyle = {
  margin: 0,
  fontFamily: "Montserrat, sans-serif",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  color: colors.text,
};

export const chipStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  padding: "7px 10px",
  borderRadius: 999,
  background: colors.primarySoft,
  color: colors.primary,
  fontFamily: "Montserrat, sans-serif",
  fontSize: "11px",
  fontWeight: 600,
  lineHeight: "15px",
};

export const sectionTitleStyle = {
  ...titleStyle,
  fontSize: "16px",
  lineHeight: "22px",
  margin: "0 0 10px 2px",
};

export const metaTitleStyle = {
  margin: 0,
  fontFamily: "Montserrat, sans-serif",
  fontSize: "13px",
  fontWeight: 700,
  lineHeight: "18px",
  color: colors.primary,
};

export const helperTextStyle = {
  margin: 0,
  fontFamily: "Montserrat, sans-serif",
  fontSize: "11px",
  color: colors.textDark,
};

export const imcCardStyle = {
  marginTop: 2,
  background: colors.primarySofter,
  borderRadius: 14,
  padding: "12px 14px",
  textAlign: "center",
};

export const imcLabelStyle = {
  margin: 0,
  fontFamily: "Montserrat, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  lineHeight: "14px",
  color: colors.primary,
  textTransform: "uppercase",
  letterSpacing: "0.03em",
};

export const imcValueStyle = {
  margin: "6px 0 0 0",
  fontFamily: "Montserrat, sans-serif",
  fontSize: 28,
  fontWeight: 700,
  lineHeight: "32px",
  color: colors.primaryDark,
};

export const SelectChevron = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M6 9L12 15L18 9"
      stroke={colors.primary}
      strokeWidth="2.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3.5" y="5.5" width="17" height="15" rx="2.5" stroke={colors.primary} strokeWidth="2" />
    <path d="M8 3.5V7" stroke={colors.primary} strokeWidth="2" strokeLinecap="round" />
    <path d="M16 3.5V7" stroke={colors.primary} strokeWidth="2" strokeLinecap="round" />
    <path d="M3.5 9.5H20.5" stroke={colors.primary} strokeWidth="2" />
    <rect x="7.5" y="12.5" width="2" height="2" rx="0.5" fill={colors.primary} />
    <rect x="11" y="12.5" width="2" height="2" rx="0.5" fill={colors.primary} />
    <rect x="14.5" y="12.5" width="2" height="2" rx="0.5" fill={colors.primary} />
  </svg>
);

export function formatDateBR(value) {
  if (!value) return "";

  const normalized = String(value).trim();

  // 👉 CORREÇÃO PRINCIPAL: trata YYYY-MM-DD sem Date()
  const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    const [, year, month, day] = match;
    return `${day}/${month}/${year}`;
  }

  // fallback (outros formatos)
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return value;

  try {
    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  } catch {
    return value;
  }
}

export function renderReadOnly(value, suffix = "") {
  const content = value ? `${value}${suffix}` : "Não informado";
  return <p style={readOnlyValueStyle}>{content}</p>;
}